import Api from '@/services/api.js';

export default {
  // addReport(report) {
  //     return Api.post('reports/add', report);
  // },
  // checkReport(report) {
  //     return Api.post('reports/checkReport', report);
  // },
  // updateReport(report) {
  //     var id = report.id;
  //     return Api.put(`reports/${id}`, report);
  // },
  getReportData(report) {
    var id = report.id;
    return Api.post(`reports/`, report);
  },
  // deleteAllReports() {
  //     return Api.delete('reports/');
  // },
  // deleteReport(id) {
  //     return Api.delete(`reports/${id}`)
  // },


}